import { HTMLAttributes } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

type DialogFooterProps = HTMLAttributes<HTMLDivElement> & {
  hideTopLine?: boolean;
};

const DialogFooter = (props: DialogFooterProps) => {
  const { className, children, hideTopLine } = props;

  return (
    <Box
      className={clsx(
        'px-5 pb-5',
        { 'border-t border-neutral-300': !hideTopLine },
        className
      )}
    >
      {children}
    </Box>
  );
};

export default DialogFooter;
